import * as Yup from 'yup';
import { buildNewPasswordRule } from '@/shared/utils';

export const validationSchema = Yup.object({
  password: buildNewPasswordRule(),
  confirmPassword: Yup.string()
    .required('Confirm password is required')
    .oneOf([Yup.ref('password')], 'Passwords must match'),
});
